import { useAudio } from './useAudio'
import { useAudioStore } from '../stores/audio'

export function createAudio(name: string, props?: any) {
  const audioStore = useAudioStore()
  audioStore.createAudioState(name, props)
  return useAudio(name)
}
